import React, { useState, useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import styles from "./DukamoBherawiPage.module.css";

// --- DEFAULT ASSETS ---
import slide1 from "../assets/Dukamo bherawi/slide1.jpg";
import slide2 from "../assets/Dukamo bherawi/slide2.jpg";
import slide3 from "../assets/Dukamo bherawi/slide3.jpg";
import coffeeSpecialtyImage from "../assets/Dukamo bherawi/try1.jpg";

// Defaults for Partnership Section
import agreementImg from "../assets/Dukamo bherawi/agreement.JPG";
import keneanImg from "../assets/Dukamo bherawi/kenean.jpg";

const defaultTopSliderImages = [slide1, slide2, slide3];

function DukamoBherawiPage() {
  const [currentTopSlide, setCurrentTopSlide] = useState(0);
  const [content, setContent] = useState({ textFields: {}, imageFields: {} });
  const [topSliderImages, setTopSliderImages] = useState(
    defaultTopSliderImages
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get("/api/pages/location-bherawi")
      .then((res) => {
        if (res.data) {
          setContent(res.data);

          // Dynamic Slider (bherawiSlider_0, bherawiSlider_1...)
          const dynamicSlider = [];
          if (res.data.imageFields) {
            for (let i = 0; i < 20; i++) {
              const key = `bherawiSlider_${i}`;
              if (res.data.imageFields[key]) {
                dynamicSlider.push(`${res.data.imageFields[key]}`);
              }
            }
          }
          if (dynamicSlider.length > 0) setTopSliderImages(dynamicSlider);
        }
      })
      .catch((err) => console.log("Using default content"));
  }, []);

  const getText = (key, fallback) =>
    content.textFields && content.textFields[key]
      ? content.textFields[key]
      : fallback;
  const getImage = (key, fallback) =>
    content.imageFields && content.imageFields[key]
      ? `${content.imageFields[key]}`
      : fallback;

  useEffect(() => {
    const topSlideInterval = setInterval(
      () => setCurrentTopSlide((prev) => (prev + 1) % topSliderImages.length),
      5000
    );
    return () => clearInterval(topSlideInterval);
  }, [topSliderImages]);

  const nextSlide = () =>
    setCurrentTopSlide((prev) => (prev + 1) % topSliderImages.length);
  const prevSlide = () =>
    setCurrentTopSlide(
      (prev) => (prev - 1 + topSliderImages.length) % topSliderImages.length
    );
  const goToTopSlide = (index) => setCurrentTopSlide(index);

  return (
    <div className={styles.locationPage}>
      <Navbar />

      {/* Intro */}
      <section className={styles.locationIntro}>
        <div className={styles.introText}>
          <h1>{getText("introTitle", "Dukamo Bherawi")}</h1>
          <p
            className={styles.introSubheading}
            style={{ whiteSpace: "pre-line" }}
          >
            {getText(
              "introText",
              "Discover Dukamo Bherawi, nestled in the vibrant Mexico area. A perfect spot for your daily coffee ritual, offering our signature brews in a cozy and modern setting. In the heart of the financial district, we serve meticulously crafted drinks, pastry and beans. Our partnership with BOA powers a fully cashless, digital experience that keeps the focus on the cup while matching the pace of the hub."
            )}
          </p>
        </div>
      </section>

      {/* Slider */}
      <section className={`${styles.imageSliderSection} ${styles.topSlider}`}>
        <div className={styles.sliderContainer}>
          {topSliderImages.map((image, index) => (
            <div
              key={`${index}-${image}`}
              className={`${styles.slide} ${
                index === currentTopSlide ? styles.active : ""
              }`}
            >
              <img src={image} alt={`Dukamo Bherawi View ${index + 1}`} />
            </div>
          ))}
          <button
            className={`${styles.sliderArrow} ${styles.prev}`}
            onClick={prevSlide}
          >
            <FaChevronLeft />
          </button>
          <button
            className={`${styles.sliderArrow} ${styles.next}`}
            onClick={nextSlide}
          >
            <FaChevronRight />
          </button>
          <div className={styles.sliderDots}>
            {topSliderImages.map((_, index) => (
              <span
                key={index}
                className={`${styles.dot} ${
                  index === currentTopSlide ? styles.active : ""
                }`}
                onClick={() => goToTopSlide(index)}
              ></span>
            ))}
          </div>
        </div>
      </section>

      {/* Feature 1 */}
      <section className={`${styles.locationFeature} ${styles.featureDrinks}`}>
        <div className={styles.featureImage}>
          <img
            src={getImage("featureImage1", coffeeSpecialtyImage)}
            alt="Specialty Coffee Beans"
          />
        </div>
        <div className={styles.featureText}>
          <h2>{getText("featureTitle1", "Experience Ethiopian Coffee")}</h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {getText(
              "featureText1",
              "From rich espressos to meticulously prepared filter coffee, our newest branch offers the full range of Dukamo's finest, ethically sourced Ethiopian beans, roasted to perfection."
            )}
          </p>
        </div>
      </section>

      {/* --- STRATEGIC PARTNERSHIP SECTION (Uses Admin Data) --- */}
      <section className={styles.digitalSection}>
        <div className={styles.digitalContainer}>
          <div className={styles.digitalTextContent}>
            <h3 className={styles.goldSubtitle}>
              {getText("partnershipSubtitle", "Strategic Partnership")}
            </h3>
            <h2 className={styles.mainHeading}>
              {getText(
                "partnershipTitle",
                "Pioneering the Digital Coffee Experience"
              )}
            </h2>
            <div className={styles.divider}></div>

            {/* --- UPDATED FULL PARAGRAPH --- */}
            <p className={styles.description}>
              {getText(
                "partnershipText1",
                "We have partnered with Bank of Abyssinia to pioneer a truly modern coffee experience. This strategic collaboration brings state-of-the-art digital payment solutions directly to our Bherawi branch, creating a fully cashless environment that is secure, fast, and convenient."
              )}
            </p>
            <p className={styles.description}>
              {getText(
                "partnershipText2",
                "By integrating advanced banking technologies into our service, we ensure that your daily ritual is never interrupted by the hassle of handling cash. From instant QR payments to seamless loyalty rewards, our digital ecosystem allows you to focus entirely on the quality of your cup and the ambiance of our space, perfectly matching the fast-paced energy of the financial district."
              )}
            </p>

            <div className={styles.bankBadge}>
              <span>Powered by</span>
              <strong>Bank of Abyssinia</strong>
            </div>
          </div>

          <div className={styles.digitalImagesWrapper}>
            {/* Image 1: Agreement (Back) */}
            <div className={styles.imageFrameBack}>
              <img
                src={getImage("partnershipBack", agreementImg)}
                alt="Dukamo x Abyssinia Agreement"
              />
            </div>

            {/* Image 2: Kenean (Front) */}
            <div className={styles.imageFrameFront}>
              <img
                src={getImage("partnershipFront", keneanImg)}
                alt="Kenean at Dukamo"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className={styles.contactHoursBottomSection}>
        <div className={styles.contactInfo}>
          <h3>Contact Us</h3>
          <p>Phone: {getText("contactPhone", "(+251) 911-234-567")}</p>
          <p>Email: {getText("contactEmail", "info@dukamocoffee.com")}</p>
        </div>
        <div className={styles.hoursInfo}>
          <h3>Hours of operation</h3>
          <p>{getText("hours", "Monday to Sunday 08:00 AM – 09:00 PM")}</p>
          <p>
            Location:{" "}
            {getText(
              "address",
              "Nile Insurance Building, Ras Abebe Aregay St, Addis Ababa"
            )}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default DukamoBherawiPage;
